
import React from "react";
import { Modal } from "react-bootstrap";

const DeleteAdmin = ({show, onHide, deleteAdmin, admin}) => {
    
  return (
    <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header >
          <Modal.Title id="contained-modal-title-vcenter">
            Delete Admin User
          </Modal.Title>
          <button type="button" className="close" onClick={onHide}>
              <span aria-hidden="true" className="d-block">×</span>
              <span className="sr-only">Close</span>
           </button>
        </Modal.Header>
        <Modal.Body>

            <h5
                className="text-center font-weight-light"
            >
                Do you really want to delete <b>{`${admin?.firstName} ${admin?.lastName} (${admin?.email})`}</b> Account?
            </h5>
            
        </Modal.Body>
        <Modal.Footer>
            <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate px-4"
            >
                Cancel
            </button>
            <> </>
            <button
                type="button"
                onClick={_ => deleteAdmin(admin.id)}
                className="btn btn-danger btn-elevate px-4 ml-4"
            >
                Delete
            </button>
        </Modal.Footer>
      </Modal>

        );
}

export default DeleteAdmin;